import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import appointmentsReducer from "../features/appointments/appointmentSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import specialitiesReducer from "../features/doctor/specialitySlice";
import doctorReducer from "../features/doctor/doctorSlice";
import componentReducer from "../features/components/componentSlice";
import authReducer from "../features/auth/authSlice";
import specialitsyReducer from "../features/speciality/specialitySlice";
import manufacturerReducer from "../features/manufacturer/manufacturerSlice";
import categoryReducer from "../features/category/categorySlice";
import supplierReducer from "../features/supplier/supplierSlice";
import customerReducer from "../features/customerHistory/customerHistorySlice";
import invoiceReducer from "../features/invoice/invoiceSlice";
import medicineFormulaReducer from "../features/medicineFormula/medicineFormulaSlice";
import batchReducer from "../features/batch/batchSlice";
import medicineReducer from "../features/medicine/medicineSlice";
import nonMedicalReducer from "../features/nonMedical/nonMedicalSlice";
import clinicReducer from "../features/clinicCms/clinicSlice";
import profileReducer from "../features/profile/profileSlice";
import userManagementReducer from "../features/staff/staffSlice";
import shiftReducer from "../features/shift/shiftSlice";
import salesReducer from "../features/sales/salesSlice";
import staffReducer from "../features/staff/staffSlice";
import salesHistoryReducer from "../features/salesHistory/salesHistorySlice";
import dashboardStatsReducer from "../features/dashboardStats/dashboardStatsSlice";
import quickReportsReducer from "../features/quickReport/quickReportSlice";
import subscriptionReducer from "../features/subscription/SubscriptionSlice";
import policyReducer from "../features/policy/policySlice";
import instructionReducer from "../features/instructions/instructionSlice";

export const store = configureStore({
  reducer: {
    appointments: appointmentsReducer,
    dashboard: dashboardReducer,
    shift: shiftReducer,
    specialities: specialitiesReducer,
    doctor: doctorReducer,
    manufacturer: manufacturerReducer,
    category:categoryReducer,
    supplier:supplierReducer,
    customer:customerReducer,
    invoice:invoiceReducer,
    medicineFormula:medicineFormulaReducer,
    batch:batchReducer,
    medicine:medicineReducer,
    nonMedical:nonMedicalReducer,
    allMedicine:medicineReducer,
    clinic:clinicReducer,
    staff: staffReducer,
    profile:profileReducer,
    userManagement:userManagementReducer,
    sales:salesReducer,
    salesHistory:salesHistoryReducer,
    dashboardStats:dashboardStatsReducer,
    quickReports:quickReportsReducer,
    subscription:subscriptionReducer,
    policy: policyReducer,
    instruction: instructionReducer,
    components: componentReducer,
    auth: authReducer,
    speciality: specialitsyReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
